import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useEditorReturn } from '../../hooks/useEditorReturn';
import CreditPaymentEditor from './CreditPaymentEditor';

function EditCreditPayment() {
	const { id } = useParams();
	const navigate = useNavigate();
	const { returnTo } = useEditorReturn();
	const backTo = returnTo || `/AdminScreen/creditPayments/creditPayment/${id}`;

	return (
		<EntityList>
			<Helmet>
				<title>Editar Pago</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Pagos', to: '/AdminScreen/creditPayments' },
					{ label: 'Editar pago' },
				]}
				title='Editar Pago'
				subtitle='Actualizá los datos del pago.'
			/>
			<CreditPaymentEditor
				mode='edit'
				creditPaymentId={id}
				onCancel={() => navigate(backTo)}
				onSaved={(savedPaymentId) => navigate(returnTo || `/AdminScreen/creditPayments/creditPayment/${savedPaymentId || id}`)}
				saveLabel='Guardar'
			/>
		</EntityList>
	);
}

export default EditCreditPayment;
